import * as types from '../mutation-types'

const state = {
  showWidget: false,
  showBrowserWarning: true
}

const getters = {
  shouldShowWidget: (state) => {
    return state.showWidget
  },
  shouldShowBrowserWarning: (state) => {
    return state.showBrowserWarning
  }
}

const actions = {
  updateShowWidget ({ commit }, showWidget) {
    commit(types.UPDATE_SHOW_WIDGET, showWidget)
  },
  checkBrowserWarning ({ commit }) {
    // Check if browserWarning localStorage key exists
    if (localStorage.getItem('browserWarning')) {
      commit(types.SET_BROWSER_WARNING, false)
    }
  },
  closeBrowserWarning ({ commit }) {
    localStorage.setItem('browserWarning', '0')
    commit(types.SET_BROWSER_WARNING, false)
  }
}

const mutations = {
  [types.UPDATE_SHOW_WIDGET] (state, showWidget) {
    state.showWidget = showWidget
  },
  [types.SET_BROWSER_WARNING] (state, showBrowserWarning) {
    state.showBrowserWarning = showBrowserWarning
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
